export const modalTableConfig = {
  title: '回复详情 - ',
  propList: [
    {
      prop: 'corpId',
      label: '企业ID',
      minWidth: '120'
    },
    { prop: 'corpName', label: '企业名称', minWidth: '120' },
    {
      prop: 'fromUser',
      label: '业务员ID',
      minWidth: '120'
    },
    {
      prop: 'empName',
      label: '业务员名称',
      minWidth: '120'
    },
    {
      prop: 'sendTime',
      label: '发送时间',
      minWidth: '120'
    },
    {
      prop: 'cname',
      label: '客户名称',
      minWidth: '120'
    },
    {
      prop: 'toUser',
      label: '客户ID',
      minWidth: '120'
    },
    {
      prop: 'cremark',
      label: '客户备注',
      minWidth: '120'
    },
    {
      prop: 'ctag',
      label: '客户标签',
      minWidth: '120'
    },
    {
      prop: 'satisfied',
      label: '是否达标',
      minWidth: '120'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
